import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Logo.module.less';
import logoImage from '../../../assets/mf_logo_black 2.png';
import { useFilters } from '../../../hooks/useFilters';
import { useAdditionalFilterStore } from '../../../stores/additionalFilterStore';

const Logo: React.FC = () => {
  const navigate = useNavigate();
  const { handleClear} = useAdditionalFilterStore();
  const {clearAllFilters} = useFilters();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    navigate('/');
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    handleClear();
    clearAllFilters();
  };

  return (
    <div className={styles.logo} onClick={handleClick}>
      <img
        src={logoImage}
        alt="METHODFUND Logo"
        className={styles.logo__image}
        width={7304}
        height={1064}
      />
    </div>
  );
};

export default Logo;
